import React from "react";
import { Form, Icon } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { SearchBar, Button, USER_PERMISSIONS, VALIDATION_PATTERNS } from "dyl-components";
import RestrictedView from "shared/RestrictedView";

const UserAccountsToolbar = ({ onOpenAddUser, setSearch }) => {
    const [query] = useSearchParams();
    const search = query.get("search") || "";

    const cancelFunction = () => setSearch("");
    const canAddUsers = useSelector(
        (state) => state.subscription.hasOpenSeats?.has_open_seat
    );
    const { isCreateUserDisabled, isReadingRoles, isReadingUserAccounts, isReadingUserProductLimts } =
        useSelector((state) => {
            return {
                isCreateUserDisabled: false,
                isReadingUserAccounts: state.assign.isReadingUserAccounts || state.subscription.isCheckingIfAccountHasOpenSeats,
                isReadingRoles: state.roles.isReadingRoles,
                isReadingUserProductLimts: state.user.isReadingUserProductLimts,
            };
        });

    return (
        <div className="UserOptions">
            <Form autoComplete='off'>
            <SearchBar
                isSearching={isReadingUserAccounts}
                search={search}
                searchFcn={setSearch}
                cancelFcn={cancelFunction}
                placeholder={"Search for a name or email address"}
                validationPattern={VALIDATION_PATTERNS.alphanumeric_w_special_chars_for_universal_search}
            />
            </Form>
            <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.USERS_ADD}>
                <Button
                    loading={isReadingRoles}
                    className="UserOptions__NewUserButton"
                    onClick={onOpenAddUser}
                    disabled={
                        isCreateUserDisabled || isReadingRoles || !canAddUsers || isReadingUserProductLimts
                    }
                >
                    <Icon name="plus" /> New User
                </Button>
            </RestrictedView>
        </div>
    );
};

export default UserAccountsToolbar;
